<template>
    <v-card class="pa-3 d-flex flex-column justify-">
        <v-img src="/img/user.png" max-width="100" class="mx-auto"></v-img>
        <div class="text-center">
            <div class="font-weight-bold mt-3">{{ `${user.prenom} ${user.nom}` }}</div>
            <div class="font-weight-medium text-medium-emphasis mt-2">{{ user.email }}</div>
        </div>
        <v-btn theme="dark" color="teal" class="mx-auto mt-3" @click="logout">Deconnexion</v-btn>
    </v-card>
</template>

<script>
export default {
    name: 'UserCard',
    props: {
        user: { type: Object, required: true }
    },
    methods: {
        logout() {
            axios.post('logout').then(() => {
                location.reload();
            });
        }
    }
};
</script>
